import { useMemo } from 'react';

import type { IColumns } from '../helpers';
import { tabsItems } from '../helpers';

import { useCatalogBaseCostWorkScopesColumns } from './useCatalogBaseCostWorkScopesColumns';
import { useCatalogUERBaseCostEstimateBasisColumns } from './useCatalogUERBaseCostEstimateBasisColumns';

export const useCatalogUerBaseCostWorkScopesColumns = ({
    activeTabId,
    onFiltersUpdated,
    currentFilterData,
}: IColumns) => {
    const workScopesColumns = useCatalogBaseCostWorkScopesColumns({
        currentFilterData,
        onFiltersUpdated,
    });
    const estimateBasisColumns = useCatalogUERBaseCostEstimateBasisColumns({
        onFiltersUpdated,
        currentFilterData,
    });

    return useMemo(() => {
        if (activeTabId === tabsItems[0].id) {
            return workScopesColumns;
        }

        if ([tabsItems[1].id, tabsItems[2].id].includes(activeTabId)) {
            return estimateBasisColumns;
        }

        return [];
    }, [activeTabId, estimateBasisColumns, workScopesColumns]);
};
